// extracted by mini-css-extract-plugin
export var quillEditor = "_gt-1";
export var variable = "_gt-0";